// import React, { createContext, useContext, useState } from "react";
// import tshirtImg from "../../../assets/images/tshirt.png"; // Example image

// const CartContext = createContext();

// export const CartProvider = ({ children }) => {
//   const [cartItems, setCartItems] = useState([
//     {
//       id: 1,
//       title: "Basic T-shirt",
//       price: 30,
//       oldPrice: 35,
//       quantity: 1,
//       image: tshirtImg,
//       color: "Blue",
//       size: "M",
//     },
//     {
//       id: 2,
//       title: "Casual Shirt",
//       price: 45,
//       oldPrice: 55,
//       quantity: 2,
//       image: tshirtImg,
//       color: "Black",
//       size: "L",
//     },
//   ]);
//   const [cartCount, setCartCount] = useState(0); // ✅ cart count from backend
//   const addToCart = (product) => {
//     setCartItems((prev) => {
//       const existingItem = prev.find((item) => item.id === product.id);
//       if (existingItem) {
//         return prev.map((item) =>
//           item.id === product.id
//             ? { ...item, quantity: item.quantity + 1 }
//             : item
//         );
//       } else {
//         return [...prev, { ...product, quantity: 1 }];
//       }
//     });
//   };

//   const removeFromCart = (id) => {
//     setCartItems((prev) => prev.filter((item) => item.id !== id));
//   };

//   const updateQuantity = (id, quantity) => {
//     setCartItems((prev) =>
//       prev.map((item) => (item.id === id ? { ...item, quantity } : item))
//     );
//   };
//   // const cartCount = cartItems.reduce((total, item) => total + item.quantity, 0);

//   return (
//     <CartContext.Provider
//       value={{
//         cartItems,
//         addToCart,
//         removeFromCart,
//         updateQuantity,
//         cartCount,
//         setCartCount,
//       }}
//     >
//       {children}
//     </CartContext.Provider>
//   );
// };

// export const useCart = () => useContext(CartContext);

import React, { createContext, useContext, useState } from "react";
import tshirtImg from "../../../assets/images/tshirt.png"; // Example image

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([
    {
      id: 1,
      title: "Basic T-shirt",
      price: 30,
      oldPrice: 35,
      quantity: 1,
      image: tshirtImg,
      color: "Blue",
      size: "M",
    },
    {
      id: 2,
      title: "Casual Shirt",
      price: 45,
      oldPrice: 55,
      quantity: 2,
      image: tshirtImg,
      color: "Black",
      size: "L",
    },
  ]);
  const [cartCount, setCartCount] = useState(0); // ✅ cart count from backend
  const addToCart = (product) => {
    setCartItems((prev) => {
      const existingItem = prev.find((item) => item.id === product.id);
      if (existingItem) {
        return prev.map((item) =>
          item.id === product.id
            ? { ...item, quantity: item.quantity + 1 }
            : item
        );
      } else {
        return [...prev, { ...product, quantity: 1 }];
      }
    });
  };

  const removeFromCart = (id) => {
    setCartItems((prev) => prev.filter((item) => item.id !== id));
  };

  const updateQuantity = (id, quantity) => {
    setCartItems((prev) =>
      prev.map((item) => (item.id === id ? { ...item, quantity } : item))
    );
  };
  // const cartCount = cartItems.reduce((total, item) => total + item.quantity, 0);

  return (
    <CartContext.Provider
      value={{
        cartItems,
        addToCart,
        removeFromCart,
        updateQuantity,
        cartCount,
        setCartCount,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
